import React, { useContext, useState } from "react";
import {
  PatientContext,
  InputVisibleContext,
  ThemeContext,
} from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import { Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import inviteProviderSchema from "./validations/inviteProviderSchema";

import theme from "../../index.scss";
import LabelledInput from "../UIComponents/LabelledInput";
import SubmitButton from "../UIComponents/SubmitButton";

import {
  sendProviderEmail,
  sendProviderEmail2,
  sendConnectExistingProviderEmail2,
  sendConnectExistingProviderEmail,
  checkProviderEmailExisting,
} from "../../api/helpReq";

const InviteProvider = ({ user, setInputVisible }) => {
  const { dark } = useContext(ThemeContext);
  const { patient } = useContext(PatientContext);
  const { t } = useTranslation();
  const { inputVisible } = useContext(InputVisibleContext);

  const [message, setMessage] = useState("");
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const { register, handleSubmit, errors, setError } = useForm({
    resolver: yupResolver(inviteProviderSchema),
  });

  const onSubmit = (data) => {
    setSubmitDisabled(true);

    data.providerEmail = data.providerEmail.toLowerCase();

    if (user.userType == "caregiver" || user.userType == "Therapist") {
      checkProviderEmailExisting({ data, patientId: patient.patientId })
        .then((res) => {
          if (res.data.exist == "false") {
            sendProviderEmail({
              data,
              patientId: patient.patientId,
              userType: user.userType,
            })
              .then(() => {
                setMessage(t("inviteprovider.messages.sent"));
                setInputVisible(false);
              })
              .catch((e) => {
                if (e.response.status === 409) {
                  setError("providerEmail", {
                    type: "alreadyHasProvider",
                    message: t("inviteprovider.messages.existing_provider"),
                  });
                }
              })
              .finally(() => {
                setSubmitDisabled(false);
              });
          } else if (res.data.exist == "true") {
            sendConnectExistingProviderEmail({
              data,
              patientId: patient.patientId,
              userType: user.userType,
            })
              .then(() => {
                setMessage(t("inviteprovider.messages.sent"));
                setInputVisible(false);
              })
              .catch((e) => {
                if (e.response.status === 409) {
                  setError("providerEmail", {
                    type: "alreadyHasProvider",
                    message: t("inviteprovider.messages.existing_provider"),
                  });
                } else {
                  console.log("An error occurred:", e);
                }
              })
              .finally(() => {
                setSubmitDisabled(false);
              });
          } else if (res.data.exist == "connectionExisting") {
            setSubmitDisabled(false);
            setMessage(t("inviteprovider.messages.existing_connection"));
            setInputVisible(false);
          } else if (res.data.exist == "existingOtherTypeAccount") {
            setSubmitDisabled(false);
            setMessage(t("inviteprovider.messages.other_account_type"));
          }
        })
        .catch((e) => {
          console.error("Error checkProviderEmailExisting");
        });
    } else {
      // patient，stroke
      checkProviderEmailExisting({ data, patientId: patient.patientId })
        .then((res) => {
          if (res.data.exist == "false") {
            sendProviderEmail2({ data, patientId: patient.patientId })
              .then(() => {
                setMessage(t("inviteprovider.messages.sent"));
              })
              .catch((e) => {
                if (e.response.status === 409) {
                  setError("providerEmail", {
                    type: "alreadyHasProvider",
                    message: t("inviteprovider.messages.existing_provider"),
                  });
                }
              })
              .finally(() => {
                setSubmitDisabled(false);
              });
          } else if (res.data.exist == "true") {
            sendConnectExistingProviderEmail2({
              data,
              patientId: patient.patientId,
            })
              .then(() => {
                setMessage(t("inviteprovider.messages.sent"));
              })
              .catch((e) => {
                if (e.response.status === 409) {
                  setError("providerEmail", {
                    type: "alreadyHasProvider",
                    message: t("inviteprovider.messages.existing_provider"),
                  });
                } else {
                  console.log("An error occurred:", e);
                }
              })
              .finally(() => {
                setSubmitDisabled(false);
              });
          } else if (res.data.exist == "connectionExisting") {
            setSubmitDisabled(false);
            setMessage(t("inviteprovider.messages.existing_connection"));
          } else if (res.data.exist == "existingOtherTypeAccount") {
            setSubmitDisabled(false);
            setMessage(t("inviteprovider.messages.other_account_type"));
          }
        })
        .catch((e) => {
          console.error("Error checkProviderEmailExisting");
        });
    }
  };

  return (
    <>
      <div className="d-flex justify-content-center">
        <h6
          id="invite-provider-button"
          className="pt-2 pb-2"
          style={{
            width: "75%",
            borderRadius: "20px",
            backgroundColor: dark ? theme.darkModePrimary : "#f7bc12",
            color: dark ? theme.darkModeText : "white",
            textAlign: "center",
            overflowWrap: "break-word",
            cursor: "pointer",
          }}
          onClick={() => setInputVisible(!inputVisible)}
        >
          {t("inviteprovider.header.0")} <br />
          {t("inviteprovider.header.1")}
        </h6>
      </div>
      {inputVisible && (
        <Row className="p-2">
          <Col>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row className="p-2">
                <Col>
                  <LabelledInput
                    required
                    label={t("inviteprovider.provider_email")}
                    name="providerEmail"
                    type="email"
                    errors={errors}
                    inputRef={register}
                  />
                  <SubmitButton type="submit" disabled={submitDisabled}>
                    {t("inviteprovider.button")}
                  </SubmitButton>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      )}
      {message && (
        <Row className="p-2">
          <Col className="text-center">{message}</Col>
        </Row>
      )}
    </>
  );
};

export default InviteProvider;